import { UpcomingExamsSchedule } from '@/components/marks/UpcomingExamsSchedule';
import { useApiQuery } from '@/hooks/useApiQuery';
import { parentApi } from '../../api/parent.api';

interface ParentUpcomingExamsTabProps {
  /** The child whose papers to read. Absent until the results header has loaded. */
  childUuid: string | undefined;
}

/**
 * The papers a child is still to sit, from `/parent/children/:uuid/exams`,
 * drawn by the schedule the student's own exams page uses.
 */
export function ParentUpcomingExamsTab({ childUuid }: ParentUpcomingExamsTabProps) {
  const { data, isLoading, error, refetch } = useApiQuery(
    () => (childUuid ? parentApi.upcomingExams(childUuid) : Promise.resolve(null)),
    [childUuid],
  );

  return (
    <UpcomingExamsSchedule
      exams={data?.exams ?? []}
      today={data?.today ?? null}
      isLoading={!childUuid || isLoading}
      error={error}
      onRetry={refetch}
      showSession
      emptyDescription={
        data?.section
          ? 'Nothing is on the exam timetable yet. Papers appear here as soon as your school publishes them.'
          : `${data?.child.fullName ?? 'Your child'} has not been placed in a class yet. Once the school office does, their exams appear here.`
      }
    />
  );
}
